import { Suspense } from 'react'
import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router'
import { useRootStore } from '@/contexts/root-store-context'
import { ContentLoading } from '@/components/ContentLoading'
import { isRefreshDesign } from '@/infra/design'
import { IamDialogsHost } from '@/features/iam/IamDialogsHost'
import { BillingDialogsHost } from '@/features/billing/BillingDialogsHost'
import { DocumentDialogsHost } from '@/features/documents/DocumentDialogsHost'
import { JobDialogsHost } from '@/features/jobs/JobDialogsHost'
import { OpportunityDialogsHost } from '@/features/opportunities/OpportunityDialogsHost'
import { OpportunityOffersHost } from '@/features/opportunities/OpportunityOffersHost'
import { NavigationContainer } from '@/features/shell/global-navigation/Navigation/NavigationContainer'
import { SidebarContainer } from '@/features/shell/global-navigation/Sidebar/SidebarContainer'

const GlobalNavigationContainer = isRefreshDesign
  ? SidebarContainer
  : NavigationContainer

export default observer(function ShellContainer() {
  const { shell } = useRootStore()

  // Call agents only get the call center, without the navigation.
  if (shell.internal.globalNavigationVm.isCallAgent) {
    return (
      <>
        <Suspense fallback={<ContentLoading />}>
          <Outlet />
        </Suspense>
        <Suspense fallback={null}>
          <IamDialogsHost />
          <BillingDialogsHost />
          <DocumentDialogsHost />
          <OpportunityOffersHost />
        </Suspense>
      </>
    )
  }

  return (
    <GlobalNavigationContainer
      floating={shell.internal.globalNavigationVm.isWorkspaceSelectorOpen}
    >
      <Suspense fallback={<ContentLoading />}>
        <Outlet />
      </Suspense>
      <Suspense fallback={null}>
        <IamDialogsHost />
        <BillingDialogsHost />
        <DocumentDialogsHost />
        <JobDialogsHost />
        <OpportunityDialogsHost />
        <OpportunityOffersHost />
      </Suspense>
    </GlobalNavigationContainer>
  )
})
